// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"83668f79","239":"3fece11d","455":"16b2e4ce"}[chunkId] + ".chunk.js";
};